import { atom } from "recoil";
import { IOnlineDirectories } from "../types";

export const addStateOnlineDirectories = atom({
  key: "addStateOnlineDirectories",
  default: false,
});
export const editStateOnlineDirectories = atom({
  key: "editStateOnlineDirectories",
  default: false,
});
export const rowEditOnlineDirectories = atom<IOnlineDirectories | undefined>({
  key: "rowEditOnlineDirectories",
  default: undefined,
});

export const selectedRowsStateOnlineDirectories = atom<IOnlineDirectories[]>({
  key: "selectedRowsStateOnlineDirectories",
  default: [],
});

export const onlineDirectoriesFilterText = atom({
  key: "onlineDirectoriesFilterText",
  default: "",
});

export const onlineDirectoriesFetching = atom({
  key: "onlineDirectoriesFetching",
  default: true,
});
export const onlineDirectoriesReFetching = atom({
  key: "onlineDirectoriesReFetching",
  default: false,
});
